PJQ.models.bidPackages = {};
PJQ.models.bidPackages.Template = PJQ.models.BaseModel.extend({
	idAttribute: 'templateId',
	notifyName: 'Template',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'bidpackages'
			},
			{
				endpoint: 'templates',
				value: this.id
			}
		], this.get('projectId') > 0 ? [
			{
				parameter: 'projectId',
				value: this.get('projectId')
			}
		] : null);
	},
	parse: function (model) {
		if (!model)
			return model;

		if (model.bidPackages != null) {
			this.bidPackages = new PJQ.collections.bidPackages.BidPackages(model.bidPackages);
		}
		else {
			this.bidPackages = null;
		}

		return model;
	}
});

PJQ.models.bidPackages.BidPackage = PJQ.models.BaseModel.extend({
	idAttribute: 'bidPackageId',
	notifyName: 'Bid Package',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'bidpackages',
				value: this.get('bidPackageId')
			}
		]);
	},
	parse: function (model) {
		if (!model)
			return model;

		this.groups = new PJQ.collections.groups.Groups(model.groups);
		this.attachments = new PJQ.collections.bidPackages.Attachments(model.attachments);

		return model;
	},
	isNew: function () {
		return this.id <= 0;
	},
	addAttachments: function (entryIds, drawingIds, tags, callback) {
		this.attachments.reset();
		if (entryIds != null) {
			_.each(_.uniq(entryIds), function (entryId) {
				this.attachments.add({
					entryId: entryId
				});
			}, this);
		}

		if (drawingIds != null) {
			_.each(_.uniq(drawingIds), function (drawingId) {
				this.attachments.add({
					drawingId: drawingId
				});
			}, this);
		}

		if (tags != null) {
			_.each(_.uniq(tags), function (tag) {
				this.attachments.add({
					drawingTagName: tag
				});
			}, this);
		}

		this.patch({
			attachments: this.attachments.toJSON()
		}, {
			success: _.bind(function () {
				if (typeof callback === 'function') {
					callback(this.attachments)
				}
			}, this),
			error: _.bind(function () {
				if (typeof callback === 'function') {
					callback(null)
				}
			}, this)
		});
	},
	beforeSave: function () {
		this.set('groups', this.groups.toJSON());
		this.set('attachments', this.attachments.toJSON());
	}
});

PJQ.models.bidPackages.Attachment = PJQ.models.BaseModel.extend({});

PJQ.collections.bidPackages = {};
PJQ.collections.bidPackages.BidPackages = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.bidPackages.BidPackage,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: this.options.projectId > 0 ? this.options.projectId : null
			},
			{
				endpoint: 'bidpackages'
			}
		]);
	}
});

PJQ.collections.bidPackages.Attachments = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.bidPackages.Attachment
})

PJQ.collections.bidPackages.Templates = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.bidPackages.Template,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'bidpackages'
			},
			{
				endpoint: 'templates'
			}
		]);
	}
});

PJQ.views.bidPackages = {};
PJQ.views.bidPackages.TemplateManagement = PJQ.views.templates.TemplateManagement.extend({
	beforeFirstRender: function () {
		this.collection = new PJQ.collections.bidPackages.Templates();
		this.listenTo(this.collection, 'fetch', this.render);
		this.collection.fetch();
	},
	addTemplate: function () {
		new PJQ.views.templates.NewTemplateModal({
			model: new PJQ.models.bidPackages.Template(),
			onSave: _.bind(function (template) {
				this.collection.add(template);
				this.dataTable.refresh();
				this.editTemplate(template);
			}, this)
		});
	},
	editTemplate: function (template) {
		new PJQ.views.bidPackages.EditTemplateModal({
			model: template,
			onClose: _.bind(function () {
				this.dataTable.refresh();
			}, this),
			onDelete: _.bind(function (template) {
				if (template.id > 0) {
					let row = this.dataTable.getRow(template.cid);
					this.collection.remove(template);
					template.destroy();
					this.dataTable.removeRow(row);
				}
			}, this)
		});
	}
});

PJQ.views.bidPackages.EditTemplateModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Edit-Bid-Package-Template'),
		maxWidth: '60%',
		fitHeight: true,
		onClose: null
	},
	events: {
		'change .cb-is-default': 'defaultChanged',
		'click .btn-close': 'close',
		'click .btn-delete': 'deleteTemplate'
	},
	defaultChanged: function () {
		this.model.patch({
			isDefault: this.$('.cb-is-default').prop('checked')
		});
	},
	beforeModalCreated: function () {
		if (!this.model) {
			this.model = new PJQ.models.bidPackages.Template({
				templateId: this.options.templateId
			})
		}

		this.listenTo(this.model, 'fetch', this.render);
		this.model.fetch();

	},
	renderData: function () {
		return {
			model: this.model
		};
	},
	afterRender: function () {
		if (this.model.isFetched) {
			new PJQ.inputs.TextEditorInput({
				el: this.$('.edit-template-name'),
				label: 'Name',
				value: this.model.get('name'),
				onSave: _.bind(function (value) {
					this.model.patch({
						name: value
					});
				}, this)
			});
		}

		new PJQ.views.bidPackages.BidPackagesView({
			el: this.$('.manage-template'),
			model: this.model,
			collection: this.model.bidPackages,
			templateId: this.model.get('templateId')
		});
	},
	close: function () {
		if (typeof this.options.onClose === 'function') {
			this.options.onClose(this.model);
		}
	},
	deleteTemplate: function () {
		new PJQ.views.modals.DeleteCancel({
			header: "Confirm Deletion",
			body: "Are you sure you want to delete this template?",
			onDelete: _.bind(function () {
				if (typeof this.options.onDelete === 'function') {
					this.options.onDelete(this.model);
				}
				this.removeModal();
			}, this)
		});
	}
});

PJQ.views.bidPackages.ManageBidPackagesModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Manage-Bid-Packages'),
		maxWidth: '60%',
		fitHeight: true,
		onClose: null
	},
	events: {
		'click .btn-close': 'close'
	},
	renderData: function () {
		return {
			projectName: this.options.project ? this.options.project.get('projectName') : ''
		};
	},
	afterRender: function () {
		new PJQ.views.bidPackages.BidPackagesView({
			el: this.$('.manage-bid-packages'),
			projectId: this.options.project ? this.options.project.get('projectId') : null,
			project: this.options.project ? this.options.project : null
		});
	},
	close: function () {
		if (typeof this.options.onClose === 'function') {
			this.options.onClose({
				changed: true
			});
		}
	}
});

PJQ.views.bidPackages.BidPackagesView = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Bid-Packages')
	},
	events: {
		'click .add-bid-package': 'addBidPackageClicked',
		'click .btn-import-template': 'importTemplate',
		'click .btn-save-a-template': 'saveAsTemplate',
		'click .btn-delete-bid-package': 'deleteBidPackageClicked',
		'click .btn-edit-bid-package': 'editBidPackageClicked'
	},
	beforeFirstRender: function () {
		if (this.collection) {
			this.listenTo(this.collection, 'fetch', this.render);
			this.render();
		}
		else if (this.options.projectId) {
			this.collection = new PJQ.collections.bidPackages.BidPackages(null, {
				projectId: this.options.projectId
			})
			this.collection.fetch({
				success: _.bind(function () {
					this.render();
					this.listenTo(this.collection, 'fetch', this.render);
				}, this)
			});
		}
		else {
			this.collection = new PJQ.collections.bidPackages.BidPackages();
		}
	},
	afterRender: function () {
		this.dataTable = new PJQ.views.dataTables.DataTable({
			el: this.$(".bid-package-table"),
			data: _.sortBy(this.collection.models, function (model) {
				return model.get('sortOrder');
			}),
			rowId: "cid",
			order: [0, 'asc'],
			sortableOptions: {
				data: this.collection,
				containment: ".bid-package-table",
			},
			bSort: false,
			scrollRows: true,
			paging: false,
			onRowDoubleClick: _.bind(function (row) {
				this.editBidPackage(row.data());
			}, this),
			language: {
				zeroRecords: 'Click "Add New Bid Package" to create a new Bid Package'
			},
			contextMenuOptions: {
				actions: [
					{
						name: 'Edit',
						onClick: _.bind(function (row) {
							this.editBidPackage(row.data());
						}, this)
					},
					{
						name: 'Delete',
						isDanger: true,
						onClick: _.bind(function (row) {
							this.deleteBidPackage(row);
						}, this)
					}
				]
			},
			columns: [
				{
					"data": "attributes.sortOrder",
					"title": "",
					"searchable": false,
					"orderable": false,
					"visible": false,
					"render": _.bind(function (data, type, row) {
						let content = '';
						if (data != null) {
							content = '<div><i class="fas fa-sort"></i></div>'
						}

						return content
					}, this)
				},
				{
					"title": "Name",
					"data": "attributes.name"
				},
				{
					"title": "Groups",
					"data": "attributes.groups",
					"render": function (data, type, row) {
						if (row.groups && _.size(row.groups.models) > 0) {
							let groupNames = [];
							_.each(row.groups.models, function (group) {
								groupNames.push(group.get('groupName'));
							});
							return groupNames.join(", ");
						}
						return '';
					}
				},
				{
					"data": "",
					"title": "",
					"orderable": false,
					"searchable": false,
					"render": _.bind(function () {
						return '<div class="text-align-right show-on-row-hover"><button type="button" class="btn btn-info btn-edit-bid-package wd-30p mr-1"><i class="fal fa-pencil"></i><button type="button" class="btn btn-danger btn-delete-bid-package wd-30p"><i class="fal fa-trash-alt"></i></button></button></div>'
					}, this),
					"width": "80px"
				}
			]
		});
	},
	addBidPackageClicked: function () {
		let newBidPackage = new PJQ.models.bidPackages.BidPackage({
			bidPackageId: null,
			name: "",
			groups: null,
			projectId: this.options.projectId,
			templateId: this.options.templateId
		});
		this.editBidPackage(newBidPackage);
	},
	importTemplate: function () {
		new PJQ.views.bidPackages.ImportTemplateModal({
			project: this.options.project,
			onImport: _.bind(function (submittals) {
				this.collection = submittals;
				this.render();
			}, this)
		});
	},
	saveAsTemplate: function () {
		new PJQ.views.bidPackages.BidPackageTemplateCreatorModal({
			collection: this.collection,
			project: this.options.project
		});
	},
	editBidPackage: function (bidPackage) {
		new PJQ.views.bidPackages.EditBidPackageModal({
			model: bidPackage,
			onSave: _.bind(function (pkg, isNew) {
				if (isNew) {
					this.collection.add(pkg);
					this.dataTable.addRow(pkg);
				}
				this.dataTable.refresh();
			}, this),
			onClose: _.bind(function (pkg) {
				if (pkg.hasChanged()) {
					pkg.fetch({
						success: _.bind(function () {
							this.dataTable.refresh();
						}, this)
					});
				}
			}, this),
			onDelete: _.bind(function (pkg) {
				let row = this.dataTable.getRow(pkg.cid);
				this.deleteBidPackage(row);
			}, this)
		});
	},
	editBidPackageClicked: function (e) {
		let target = $(e.currentTarget),
			row = this.dataTable.getRow(target.closest('tr')),
			pkg = row.data();

		this.editBidPackage(pkg);
	},
	deleteBidPackageClicked: function (e) {
		let target = $(e.currentTarget),
			row = this.dataTable.getRow(target.closest('tr'));
		this.deleteBidPackage(row);
	},
	deleteBidPackage: function (row) {
		let pkg = row.data();
		new PJQ.views.modals.DeleteCancel({
			header: "Confirm Deletion",
			body: "Are you sure you want to delete this Bid Package?",
			onDelete: _.bind(function () {
				this.collection.remove(pkg);
				pkg.destroy();
				this.dataTable.removeRow(row);
			}, this)
		});
	}
});

PJQ.views.bidPackages.EditBidPackageModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Edit-Bid-Package'),
		maxWidth: '50%',
		onClose: null
	},
	events: {
		'click .btn-close': 'close',
		'click .btn-delete': 'deleteBidPackage',
		'click .btn-save': 'save'
	},
	// beforeModalCreated: function () {
	//     // this.listenTo(this.model, 'fetch', this.render);
	//     // this.model.fetch();
	// },
	renderData: function () {
		return {
			model: this.model
		};
	},
	afterRender: function () {
		new PJQ.Binder(this.$el, this.model, {
			watchElements: [
				'input',
				'textarea'
			]
		});
		let groupUserId = PJQ.app.session.get('masterUserId'),
			groupLevels = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LEVELS)
		if (this.model.groups == null) {
			this.model.groups = new PJQ.collections.groups.Groups([], {
				groupLevels: groupLevels
			});
		}
		new PJQ.views.groups.GroupsSelectInput({
			el: this.$('.bid-package-groups'),
			isShowAddButton: false,
			groupLevels: groupLevels,
			groupUserId: groupUserId,
			isReadOnly: false,
			addButton: this.$('.btn-edit-groups'),
			selectedGroups: this.model.groups.models,
			onAfterSave: _.bind(function (selectedGroups) {
				this.model.groups.reset(selectedGroups);
				this.model.isDirty = true;
			}, this)
		});
	},
	close: function () {
		if (typeof this.options.onClose === 'function') {
			this.options.onClose(this.model);
		}
		this.removeModal();
	},
	save: function () {
		if (this.model.hasChanged() || this.model.isNew()) {
			let isNew = false;
			if (this.model.isNew()) {
				isNew = true;
			}
			this.model.save(null, {
				notify: true,
				success: _.bind(function () {
					if (this.options.onSave) {
						this.options.onSave(this.model, isNew);
					}
					this.removeModal();
				}, this)
			});
		}
		else {
			this.removeModal();
		}
	},
	deleteBidPackage: function () {
		if (typeof this.options.onDelete === 'function') {
			this.options.onDelete(this.model);
		}
		this.removeModal();
	}
});

PJQ.views.bidPackages.ImportTemplateModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'modal-import-bid-package-template'),
		maxWidth: 500,
		onImport: null
	},
	events: {
		'click .btn-import': 'save'
	},
	beforeModalCreated: function () {
		PJQ.app.session.fetchBidPackageTemplates(_.bind(function (tmp) {
			this.templates = tmp;
			this.render();
		}, this));
	},
	renderData: function () {
		return {
			templates: this.templates
		};
	},
	afterRender: function () {
		if (this.templates != null && this.templates.isFetched) {
			this.templatePicker = new PJQ.inputs.Selectpicker({
				el: this.$('.select-template'),
				onChange: _.bind(function (value) {
					this.selectedTemplate = this.templates.get(value);
				}, this),
				isIntChoices: true,
				noneSelectedText: 'Select Template'
			});

		}
	},
	save: function () {
		let isValid = true;
		if (this.selectedTemplate == null) {
			this.templatePicker.showError();
			isValid = false;
		}
		else {
			this.templatePicker.hideError();
		}


		if (!isValid) {
			return;
		}

		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'projects',
					value: this.options.project.id
				},
				{
					endpoint: 'bidpackages'
				},
				{
					endpoint: 'import',
					value: this.selectedTemplate.id
				}
			])
		}).get().done(_.bind(function (response) {
			if (typeof this.options.onImport === 'function') {
				let result = new PJQ.collections.bidPackages.BidPackages(response);
				result.isFetched = true;
				this.options.onImport(result);
			}
			this.removeModal();
			PJQ.notifications.notify.successNotify({
				message: 'Bid Package Template Imported'
			});
		}, this));
	}
});

PJQ.views.bidPackages.BidPackageTemplateCreatorModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'modal-create-bid-package-template'),
		width: '30%'
	},
	events: {
		'click .btn-save': 'save'
	},
	beforeModalCreated: function () {
		this.model = new PJQ.models.bidPackages.Template({
			projectId: this.options.project.id
		});

		PJQ.app.session.fetchBidPackageTemplates(_.bind(function (tmp) {
			this.templates = tmp;
			this.render();
		}, this));
	},
	renderData: function () {
		return {
			templates: this.templates,
			bidPackages: this.collection
		};
	},
	afterRender: function () {
		if (this.templates != null && this.templates.isFetched) {
			new PJQ.inputs.Selectpicker({
				el: this.$('.select-bid-package'),
				isMultiple: true,
				noneSelectedText: 'Select Bid Package',
				onChange: _.bind(function (value) {

				}, this)
			});

			new PJQ.inputs.AutocompleteInput({
				el: this.$('.input-template-name'),
				source: _.map(this.templates.models, function (template) {
					return template.get('name')
				})
			});
		}
	},
	save: function () {
		let $name = this.$('.input-template-name'),
			name = $name.val();
		if (_.size(name.trim()) === 0) {
			PJQ.helpers.inputHelpers.setInputError($name);
			return;
		}
		else {
			PJQ.helpers.inputHelpers.setInputError($name, true);
		}

		let existingTemplate = this.templates.findWhere({name: name}),
			fnSave = _.bind(function () {
				this.model.set({
					name: name
				});
				this.model.save(null, {
					success: _.bind(function () {
						this.removeModal();
						PJQ.notifications.notify.successNotify({
							message: 'Bid Package Template Created'
						});
					}, this)
				});
			}, this);
		if (existingTemplate != null) {
			new PJQ.views.modals.YesNo({
				header: "Overwrite Template",
				body: "A template already exists with this name.  Would you like to overwrite it?",
				onYes: _.bind(function () {
					this.model.set('templateId', existingTemplate.id);
					fnSave();
				}, this)
			});
		}
		else {
			fnSave();
		}
	}
});

PJQ.views.bidPackages.SelectBidPackagesModal = PJQ.views.BaseModal.extend({
	defaults: {
		isSingleChoice: false,
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Bid-Packages-Select'),
		alertText: null,
		onSave: null
	},
	events: {
		"click .bid-packages-select-save": "onSave"
	},
	renderData: function () {
		return {
			options: this.options
		};
	},
	afterRender: function () {
		this.bidPackageSelector = new PJQ.views.bidPackages.BidPackageSelector({
			el: this.$('.bid-packages-selector'),
			isEnableSelectedFilter: false,
			onBidPackageSelected: _.bind(this.checkBidPackagesSelected, this),
			project: this.options.project
		});
	},
	checkBidPackagesSelected: function (bidPackagesData) {
		this.$('.bid-packages-select-save').prop('disabled', _.size(bidPackagesData.new) === 0 && _.size(_.difference(_.map(bidPackagesData.original, function (bidPackage) {
			return bidPackage.id;
		}), _.map(bidPackagesData.selected, function (bidPackage) {
			return bidPackage.id
		}))) === 0);
		this.onSave()
	},
	onSave: function () {
		if (typeof this.options.onSave === 'function') {
			this.options.onSave(this.bidPackageSelector.getData());
		}
		this.removeModal();
	},
});

PJQ.views.bidPackages.BidPackageSelector = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Bid-Package-Selector-Container'),
		subTemplates: {
			selector: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Bid-Package-Selector')
		},
		bidPackages: null,
		includeBidPackageIds: null,
		selectedBidPackageIds: null,
		disabledBidPackageIds: null,
		selectedBidPackages: null,
		onBidPackagesLoaded: null,
		onBidPackageSelected: null,
		isAdmin: false,
		isEnableSelectAll: false,
		isDisableSelected: false,
		isHideDisabled: false,
		isExpandSelected: true,
		canEdit: true,
		onSelect: _.noop,
		isSingleChoice: false,
		headerButtons: null,
		isIncludeGroups: false,
		onSelected: _.noop
	},
	events: {
		"keyup .bid-package-search": "renderBidPackages",
		"click .btn-header-action": "headerAction",
		"click .bid-package-all-select": "selectAll",
		"click .bid-package-expand": "expandParentClick",
		"click .bid-package-select": "selectBidPackage",
		"click .group-select": "selectGroup"
	},
	afterRender: function () {
		this.selectedGroupIds = [];
		this.selectedBidPackageIds = [];
		if (this.options.bidPackages == null) {
			this.getBidPackages();
		}
		else {
			this.afterSync();
		}
	},
	getBidPackages: function () {
		if (this.collection != null) {
			this.collection.fetch({
				success: _.bind(function () {
					this.afterSync();
				}, this)
			});
		}
		else if (this.options.project) {
			this.collection = new PJQ.collections.bidPackages.BidPackages(null, {
				projectId: this.options.project.id
			})
			this.collection.fetch({
				success: _.bind(function () {
					this.afterSync();
				}, this)
			});
		}
		else {
			this.collection = new PJQ.collections.bidPackages.BidPackages();
			this.afterSync()
		}
	},
	afterSync: function () {
		this.options.isBidPackagesLoaded = true;
		this.loadBidPackages();
	},
	loadBidPackages: function () {
		if (this.removed) {
			return;
		}

		this.renderBidPackages();

		if (typeof this.options.onBidPackagesLoaded === 'function') {
			this.options.onBidPackagesLoaded();
		}
	},
	renderBidPackages: function () {
		let searchFilter = this.$('.bid-package-search').val().toLowerCase(),
			bidPackages = [];

		if (_.size(searchFilter) > 0) {
			_.each(this.collection.models, _.bind(function (model) {
				if (model.get('name').toLowerCase().indexOf(searchFilter) > -1)
					bidPackages.push(model);
			}, this));
		}
		else {
			this.$('.bid-package-clear-filters').prop('disabled', true);
			bidPackages = this.collection.models;
		}

		let data = {
			models: bidPackages,
			options: this.options,
		};
		this.renderSubTemplate(false, this.options.subTemplates.selector, this.$('.bid-packages-container'), data, _.bind(function () {
			if (this.options.isHideDisabled) {
				this.$('.bid-package-select:disabled').closest('.bid-package-select-container').hide();
			}
			this.isRendered = true;
		}, this));
	},
	showError: function (errorText) {
		this.hideError();
		this.errorAlert = new PJQ.Alert(this.$el, {
			type: 'danger',
			extraClasses: ['mt-1, mb-1'],
			text: errorText,
			isPrepend: true
		});
	},
	hideError: function () {
		if (this.errorAlert) {
			this.errorAlert.destroy();
		}
	},
	reload: function (userId) {
		this.getBidPackages();
	},
	getParentChildContainer: function (parent) {
		return parent.closest('.pretty').siblings('.group-child-container');
	},
	expandParentClick: function (e) {
		this.expandParent($(e.currentTarget).siblings('.group-child-container'));
	},
	expandParent: function (container) {
		let icon = container.siblings('i.bid-package-expand');
		if (container.hasClass('hidden')) {
			container.removeClass('hidden');
			icon.removeClass('fa-chevron-down text-primary');
			icon.addClass('fa-chevron-up text-muted');
		}
		else {
			container.addClass('hidden');
			icon.removeClass('fa-chevron-up text-muted');
			icon.addClass('fa-chevron-down text-primary');
		}
	},
	getData: function () {
		let groupIds = [],
			bidPackageIds = [];
		_.each(this.collection.models, function (bidPackage) {
			if (bidPackage.get('isSelected')) {
				bidPackageIds.push(bidPackage.get('bidPackageId'))
			}
			_.each(bidPackage.groups.models, function (group) {
				if (group.get('isSelected')) {
					groupIds.push(group.get('groupId'));
				}
			}, this)
		}, this);

		if (typeof this.options.onSelected === 'function') {
			this.options.onSelected(groupIds, bidPackageIds);
		}
		return {groupIds, bidPackageIds};
	},
	selectBidPackage: function (e) {
		let childContainer = this.getParentChildContainer($(e.currentTarget)),
			isChecked = $(e.currentTarget).is(':checked'),
			bidPackageId = $(e.currentTarget).data('bid-package-id'),
			bidPackage = this.collection.get(bidPackageId);

		let groupSelects = [];
		groupSelects = childContainer.find('.bid-package-select')
		childContainer.find('.group-select').prop('checked', isChecked);

		bidPackage.set('isSelected', isChecked);
		_.each(bidPackage.groups.models, function (group) {
			group.set('isSelected', isChecked);
		}, this)

		if (isChecked) {
			//If its checked, expand the parents/sub-parents to show the groups that were selected
			if (childContainer.hasClass('hidden')) {
				this.expandParent(childContainer);
			}
		}

		this.$('.bid-package-all-select').prop('checked', !(this.$('.group-select:not(:checked)').length > 0));

		this.getData();
	},
	selectAll: function () {
		let groupSelects = this.$('.group-select'),
			bidPackageSelects = this.$('.bid-package-select')
		if (this.$('.bid-package-all-select').prop('checked')) {
			_.each(this.collection.models, function (model) {
				model.set('isSelected', true);
				_.each(model.groups.models, function (group) {
					group.set('isSelected', true);
				}, this)
			}, this)
			groupSelects.prop('checked', true);
			bidPackageSelects.prop('checked', true);
		}
		else {
			_.each(this.collection.models, function (model) {
				model.set('isSelected', false);
				_.each(model.groups.models, function (group) {
					group.set('isSelected', false);
				}, this)
			}, this)
			groupSelects.prop('checked', false);
			bidPackageSelects.prop('checked', false);
		}
		this.getData();
	},
	selectGroup: function (e) {
		let $target = $(e.currentTarget),
			groupId = $target.data('group-id'),
			bidPackageId = $target.data('bid-package'),
			bidPackage = this.collection.get(bidPackageId),
			removeBidPackage = true,
			group = _.find(bidPackage.groups.models, function (group) {
				return group.get('groupId') === groupId;
			}),
			isChecked = $(e.currentTarget).is(':checked'),
			bidPackageSwitch = this.$('.bid-packages-container').find('[data-bid-package-id="' + bidPackageId + '"]')

		group.set('isSelected', isChecked);
		if (isChecked && !bidPackage.get('isSelected')) {
			bidPackage.set('isSelected', true);
			bidPackageSwitch.prop('checked', isChecked);
		}

		if (!isChecked) {
			_.each(bidPackage.groups.models, function (group) {
				if (group.get('isSelected')) {
					removeBidPackage = false;
				}
			})

			if (removeBidPackage) {
				bidPackageSwitch.prop('checked', isChecked);
				bidPackage.set('isSelected', false);
			}
		}
		this.$('.bid-package-all-select').prop('checked', !(this.$('.group-select:not(:checked)').length > 0));
		this.getData();
	}
});

PJQ.views.bidPackages.BidPackageRadiusModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Bid-Package-Radius'),
		alertText: null,
		onSave: null,
		maxWidth: "400px",
		defaultRadius: 50
	},
	events: {
		"click .add-participants": "addParticipants",
		'keyup .add-participants-radius': 'radiusChanged'
	},
	beforeModalCreated: function () {
		let prefs;
		if (this.options.project != null) {
			prefs = this.options.project.preferences;
		}
		else {
			prefs = PJQ.app.session.preferences;
		}

		let radiusPref = prefs.getPref(PJQ.constants.preferenceTypes.ADD_PARTICIPANTS_BID_PACKAGE_RADIUS);
		if (radiusPref != null && radiusPref > 0) {
			this.options.defaultRadius = radiusPref;
		}
	},
	renderData: function () {
		return {
			options: this.options
		};
	},
	afterRender: function () {
		this.directoryFilterSelectPicker = new PJQ.inputs.Selectpicker({
			el: this.$('.directory-filter'),
			isIntChoices: true,
			isMultiple: true,
			mustSelectValue: true,
			defaultValue: [1,2]
		});

		this.radiusSlider = new PJQ.Slider(this.$('.add-participants-radius-slider'), {
			ticks: [1, 50, 100, 150, 200, 250, 300],
			ticks_labels: [1, 50, 100, 150, 200, 250, 300],
			value: this.options.defaultRadius,
			onChange: _.bind(function (obj) {
				this.setRadius(obj.newValue);
			}, this)
		});
	},
	radiusChanged: function () {
		this.setRadius(parseInt(this.$('.add-participants-radius').val()));
	},
	setRadius: function (radius) {
		if (isNaN(radius) || radius < 1)
			radius = 1;
		else if (radius > 300)
			radius = 300;
		this.radiusSlider.setValue(radius);
		//don't set the radius input yet if the length of the value is 0 in case the user is trying to clear the input to enter a new value
		if (this.$('.add-participants-radius').val().length > 0)
			this.$('.add-participants-radius').val(radius);
	},
	addParticipants: function () {
		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'projects',
					value: this.options.project.id
				},
				{
					endpoint: 'participants',
					value: 'bidPackages'
				}
			], [
				{
					parameter: 'radius',
					value: this.radiusSlider.getValue()
				},
				{
					parameter: 'directoryFilter',
					value: _.size(this.directoryFilterSelectPicker.getValue()) === 2 ? 0 : this.directoryFilterSelectPicker.getValue()[0]
				}
			])
		}).post().done(_.bind(function (data) {
			if (typeof this.options.onSave === 'function') {
				this.options.onSave(data)
			}
			if (_.size(data) > 0) {
				PJQ.notifications.notify.successNotify({
					message: 'Participants successfully added'
				});
			}
			else {
				PJQ.notifications.notify.successNotify({
					message: 'No participants were added'
				});
			}
			this.removeModal();
		}, this)).fail(_.bind(function () {
			PJQ.notifications.notify.errorNotify({
				message: 'Encountered an error adding participants.  Please contact customer service.'
			});
		}, this));
	}
});

